
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    article: {
      type: Object,
      required: true,
    },
  },
}
